import { tvpil } from '../../data/compat/tvpil';
import { RhinoError } from '../../error';
import { createDeferred, Deferred } from '../../util';

// This module exists bc we need to sync ks refresh process of tvpil with new `requestPhoenix()`.
// Tvpil refresh ks middleware should call above `start`/`complete` functions, so `getUpToDateKs` checks
// whether ks refresh process is going on and waits until refresh is completed to return valid ks.
let ksRefreshingDeferred: Deferred | undefined;

const REFRESH_KS_FAILED = 'REFRESH_KS_FAILED';

export function getKsRefreshDeferred() {
  return ksRefreshingDeferred ?? Promise.resolve();
}

export function isRefreshInProcess() {
  return Boolean(ksRefreshingDeferred);
}

export async function getKsAndWaitIfRefreshing() {
  if (ksRefreshingDeferred === undefined) return tvpil.appStore.loginStore.ks;

  const result = await ksRefreshingDeferred;

  if (result === REFRESH_KS_FAILED) {
    throw new RhinoError('NETWORK_API_ERROR', 'ks refresh failed');
  }

  return tvpil.appStore.loginStore.ks;
}

export function createRefreshKsDeferred() {
  // there could be situation that both rxjs client and `requestPhoenix` could simultaneously try
  // to refresh ks. In this case, the second one just waits for the first one to complete.
  if (!ksRefreshingDeferred) ksRefreshingDeferred = createDeferred();
}

export function resolveRefreshKsDeferred() {
  if (ksRefreshingDeferred) {
    ksRefreshingDeferred.resolve();
    ksRefreshingDeferred = undefined;
  }
}

export function rejectRefreshKsDeferred(e: unknown) {
  if (ksRefreshingDeferred) {
    ksRefreshingDeferred.resolve(REFRESH_KS_FAILED);
    ksRefreshingDeferred = undefined;
  }
}
